import { useEffect, useState } from 'react';

export const useDrawerHeightListener = (el: Element | null): number => {
  const [drawerHeight, setDrawerHeight] = useState(0);

  useEffect(() => {
    if (!el) return () => {};

    let lastValue = '';

    const checkOverlayHeight = (): void => {
      const value = getComputedStyle(el).getPropertyValue('--rsbs-overlay-h');
      if (value && value !== lastValue) {
        lastValue = value;
        const parsedHeight = parseFloat(value.trim().replace('px', '')) || 0;
        setDrawerHeight(parsedHeight);
      }
    };

    // Initial read
    checkOverlayHeight();

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'style'
        ) {
          checkOverlayHeight();
        }
      }
    });

    observer.observe(el, {
      attributes: true,
      attributeFilter: ['style'],
    });

    return () => {
      observer.disconnect();
    };
  }, [el]);

  return drawerHeight;
};
